import { render, staticRenderFns } from "./HowToBidPage.vue?vue&type=template&id=73cbeeca&scoped=true&"
import script from "./HowToBidPage.vue?vue&type=script&lang=js&"
export * from "./HowToBidPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cbeeca",
  null
  
)

export default component.exports